import React from "react";
import AuthForm from "./components/AuthForm";

function SignUp() {
  return <AuthForm isSignUp={true} />;
}

export default SignUp;
